import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { IconButton, Popover } from "@mui/material";
import { type FC } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { ChartSettingEnum } from "~/feature/chart/types";

import * as Styled from "./ChartSettings.styles";
import { chartSettingsTitle, labelByChartSetting } from "./constants";
import { useChartSettings } from "./useChartSettings";

export const ChartSettings: FC = () => {
  const { settings, toggleSetting } = useCoreChart();
  const { anchorEl, isOpen, handleOpen, handleClose } = useChartSettings();

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <SettingsOutlinedIcon fontSize="small" />
      </IconButton>

      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Styled.Root>
          <Styled.Caption>{chartSettingsTitle}</Styled.Caption>

          {Object.values(ChartSettingEnum).map((setting) => (
            <Styled.Row
              key={setting}
              labelPlacement="start"
              label={labelByChartSetting[setting]}
              control={
                <Styled.Switch
                  checked={settings[setting]}
                  onChange={() => toggleSetting(setting)}
                />
              }
            />
          ))}
        </Styled.Root>
      </Popover>
    </>
  );
};
